module.exports = __webpack_public_path__ + "static/media/DOGE-BNB-PCS.5755e6ff.svg";